export default {
  common: {
    selfExplanation: "自我说明",
    prompt: "提示",
    dontDisplayAgain: "不再显示此提示信息。",
    continue: "继续",
    goBack: "返回",

    cantFindTheCode: "无法找到代码: ",
    noContent: "无内容",
    promptDisabledReopen: "您可以在 [首页]->[我的] 页面中再次打开它。",

    what: "什么内容：",
    why: "为什么：",
    learn: "学习",
    toLearnOpen: "要了解更多信息，请打开"
  },
  E1000: {
    topic: "目标",
    content_1_M: "为本项目选择性能目标，例如冷水机、冷水机房或供热系统。供热机房及冷暖联合选项即将推出。",
    content_2_M: "此选择通过定义系统边界、所需输入、适用的设备配置以及用于评估改进机会的性能指标来驱动 iECM 工作流。"
  },
  E10200: {
    topic: "概况",
    content_1_M: "设置项目概况，包括用途、设计工况、冷水机配置、气象数据，以及（如适用）水泵配置。",
    content_2_M: "这些信息帮助 iECM 根据所选目标、系统类型和设备配置定制工作流、输入字段和能源审计逻辑。"
  },
  E10300: {
    topic: "现有设备规格",
    content_1_M: "根据所选目标输入现有现场设备详情，包括冷水机及其他适用的机房组件。",
    content_2_M: "这有助于 iECM 了解当前系统，并为能源审计和改造分析应用正确的设备数据。"
  },
  E10400: {
    topic: "现场观察",
    content_1_M: "记录客户现场审查中的关键发现、建议、预期收益及佐证照片。",
    content_2_M: "这些记录解释了为何需要改造，并强化了能源审计和方案建议的商业理由。"
  },
  E10500: {
    topic: "基线配置",
    content_1_M: "选择构建客户当前能耗基线的最佳数据路径。使用冷负荷信息或能耗账单，然后设置运行月份以及峰值和非峰值时段的电价。",
    content_2_M: "此选择定义了月度基线工作流，并帮助 iECM 为能源审计和年度节能估算构建参考方案。"
  },
  E10610: {
    topic: "月度基线",
    content_1_M: "添加或编辑客户基线月份的运行概况。iECM 使用该概况估算全年其余月份的冷负荷并计算月度冷水机功率。",
    content_2_M: "这构建了可信的当前状态基线，使年度节能量和改造价值能够清晰对比。"
  },
  E10611: {
    topic: "运行日历",
    content_1_M: "定义客户系统在此基线下的运行时间，例如工作日、周末或整周。月度运行天数将自动计算。",
    content_2_M: "运行天数显示系统每月及全年的运行频率，构成年度负荷、能耗和节能计算的基础。"
  },
  E10612: {
    topic: "运行小时",
    content_1_M: "通过将每个小时标记为峰值、非峰值或停机，定义24小时基线月运行时间表。",
    content_2_M: "这将冷水机运行与各时段相应的气象数据关联起来，帮助 iECM 更准确地计算负荷和功率。"
  },
  E10613: {
    topic: "参考冷机",
    content_1_M: "选择峰值和非峰值时段使用的现场冷水机，然后选择最接近的开利代理型号来代表其性能。",
    content_2_M: "iECM 使用代理型号和校准输入来模拟客户冷水机性能，并更准确地计算月度基线功率。"
  },
  E10614: {
    topic: "运行负荷",
    content_1_M: "设置基线日每小时运行的冷水机数量及其负荷率。iECM 随后计算每小时冷负荷。",
    content_2_M: "这有助于 iECM 构建年度冷负荷概况，并估算在不同月度气象条件下所需的冷水机数量。"
  },
  E10615: {
    topic: "月度冷负荷",
    content_1_M: "查看每月的加权平均冷负荷。基线月份基于每小时输入，而其他月份由 iECM 估算。",
    content_2_M: "这些月度负荷定义了冷需求基线，用于估算冷水机运行、能耗以及与改造方案对比的节能量。"
  },
  E10616: {
    topic: "月度冷机数量",
    content_1_M: "根据月度冷负荷和可用冷水机容量，查看每月峰值和非峰值运行所需的最小冷水机数量。",
    content_2_M: "这有助于 iECM 估算现有冷水机全年的运行情况，并支持月度基线功率和能耗计算。"
  },
  E10617: {
    topic: "冷机功率",
    content_1_M: "查看峰值和非峰值时段的月度平均冷水机功率，由代理冷水机型号、冷负荷和冷水机数量计算得出。",
    content_2_M: "此功率概况用于估算改造前冷水机能耗，并与改造方案进行节能对比。"
  },
  E10620: {
    topic: "月度基线",
    content_1_M: "根据客户的运行模式（如工作日和周末运行）添加或编辑月度基线配置。",
    content_2_M: "这些基线组织了公用事业账单工作流，帮助 iECM 构建当前能耗基线，以进行年度节能和改造价值对比。"
  },
  E10621: {
    topic: "运行日历",
    content_1_M: "定义客户系统在此基线下的运行时间，例如工作日、周末或整周。月度运行天数将自动计算。",
    content_2_M: "运行天数显示系统每月及全年的运行频率，构成年度负荷、能耗和节能计算的基础。"
  },
  E10622: {
    topic: "运行小时",
    content_1_M: "根据客户的运行时间表，输入每月峰值和非峰值时段的每日运行小时数。",
    content_2_M: "这将冷水机运行与各时段相应的气象数据关联起来，帮助 iECM 更准确地计算功率。"
  },
  E10623: {
    topic: "参考冷机",
    content_1_M: "选择峰值和非峰值时段使用的现场冷水机，然后选择最接近的开利代理型号来代表其性能。",
    content_2_M: "iECM 使用代理型号和校准输入来模拟客户冷水机性能，并更准确地计算月度基线冷负荷。"
  },
  E10624: {
    topic: "能耗",
    content_1_M: "使用公用事业账单数据输入客户峰值和非峰值时段的月度能耗。",
    content_2_M: "这有助于 iECM 将账单数据转换为运行基线，包括估算冷水机功率、所需冷水机数量和冷负荷需求。"
  },
  E10625: {
    topic: "冷机功率",
    content_1_M: "查看根据客户公用事业账单数据计算的峰值和非峰值时段月度加权平均冷水机功率。",
    content_2_M: "此加权平均功率用于估算冷水机运行、冷负荷需求以及与改造方案对比的节能量。"
  },
  E10626: {
    topic: "月度冷机数量",
    content_1_M: "根据月度平均冷功率和可用冷水机功率，查看每月峰值和非峰值运行所需的最小冷水机数量。",
    content_2_M: "这有助于 iECM 估算现有冷水机全年的运行情况，并支持月度冷负荷基线和能耗计算。"
  },
  E10627: {
    topic: "月度冷负荷",
    content_1_M: "查看根据公用事业账单数据、代理冷水机性能、月度冷水机功率和冷水机数量得出的月度加权平均冷负荷。",
    content_2_M: "此冷负荷概况代表改造前后相同的建筑需求，使现有设备与拟议设备能够公平对比。"
  },
  E10628: {
    topic: "辅助功率",
    content_1_M: "输入辅助设备（如水泵和冷却塔）在峰值和非峰值时段的实际加权平均运行功率（kW）。",
    content_2_M: "这有助于 iECM 将辅助设备能耗纳入当前基线，并更准确地计算改造前总能耗。"
  },
  E10700: {
    topic: "基线预览",
    content_1_M: "查看并下载改造前基线能源审计结果，包括每小时冷负荷、估算功率，以及按设备类型分类的月度负荷和功率。",
    content_2_M: "这确认了改造前基线结果，并在改造后建模开始之前生成可供客户使用的能源审计报告。"
  },
  E10800: {
    topic: "设置运行工况",
    content_1_M: "选择新冷水机类型并设置改造后运行工况，例如冷冻水温度和冷凝器侧设定值。",
    content_2_M: "这有助于 iECM 配置改造后设置，并根据所选设备类型估算性能。"
  },
  E10900: {
    topic: "定义新设备",
    content_1_M: "添加并定义改造方案中使用的新设备，包括冷水机、水泵和冷却塔（如适用）。每个条目代表一个设备单元。",
    content_2_M: "每个设备选项只需定义一次。iECM 计算所需的运行数量，并据此估算改造性能、节能量和投资回报率。"
  },
  E10901: {
    topic: "数字化 e-CAT",
    content_1_M: "从数字 e-CAT 中选择新冷水机，设置设计工况和销售价格，并查看其性能曲线。",
    content_2_M: "这使冷水机选型更快捷便利，同时提供改造分析和节能计算所需的性能数据。单位销售价格用于估算项目总资本支出（CAPEX）。"
  },
  E10902: {
    topic: "聚类月份",
    content_1_M: "当数字 e-CAT 库中没有所需冷水机时，使用聚类月份。将相似月份归类，然后输入冷水机详情和 e-CAT 性能数据。",
    content_2_M: "月份归类减少了重复的 e-CAT 输入，而手动录入使 iECM 能够分析自定义冷水机以进行改造分析和节能计算。单位销售价格用于估算总资本支出（CAPEX）。"
  },
  E10903: {
    topic: "水泵",
    content_1_M: "定义新水泵，并将其关联到改造方案中它将支持的冷水机。",
    content_2_M: "这通过将每个水泵与相应的运行冷水机匹配，帮助 iECM 正确建模拟议方案。"
  },
  E10904: {
    topic: "冷却塔",
    content_1_M: "定义新冷却塔，并将其关联到改造方案中它将支持的冷水机。",
    content_2_M: "这通过将每个冷却塔与相应的运行冷水机匹配，帮助 iECM 正确建模拟议方案。"
  },
  E11000: {
    topic: "改造方案",
    content_1_M: "查看 iECM 生成的改造方案，按效率、投资回报率或投资额排序，并完成每个选项所需的配置。生成 ECM 报告或为自定义设置重新配置方案。",
    content_2_M: "这有助于您选择最有力的客户方案，微调投资回报率、净现值和拟议配置，并生成最终 ECM 报告。"
  },
  E12000: {
    topic: "重新配置方案",
    content_1_M: "通过为每个基线和运行时段选择关联冷水机及最大运行数量，手动配置改造方案。",
    content_2_M: "当自动生成的方案不是最适合客户时，这为您提供了定制方案的灵活性。"
  },
  E11001: {
    topic: "改造配置",
    content_1_M: "查看改造方案的详细配置，包括最大冷负荷、拟议冷水机容量和月度运行设备数量。",
    content_2_M: "这在用于财务分析和最终 ECM 报告之前，确认了拟议系统的选型和运行方式。"
  },
  E11002: {
    topic: "投资回报率与净现值",
    content_1_M: "查看并更新方案的全生命周期财务表现，包括冷水机房或冷水机的节能量、成本节省、投资回报率、回收期和净现值。",
    content_2_M: "这向客户展示了该方案如何提高效率、降低运营成本并带来长期财务价值，包括投资回报率和净现值。"
  },
  E11003: {
    topic: "拟议设备详情",
    content_1_M: "通过选择保留哪些现有设备及由哪些新设备替换，定义详细的改造范围和配置。",
    content_2_M: "这阐明了拟议的设备变更，有助于创建完整、可供客户使用的改造计划和 ECM 报告。"
  },
  E11004: {
    topic: "拟议配置",
    content_1_M: "输入要包含在最终 ECM 报告中的分析假设、系统详情和节能措施。",
    content_2_M: "这有助于创建完整、可供客户使用的报告，清晰说明改造依据、拟议措施和预期价值。"
  },

  // HEATING
  E2000: {
    topic: "目标",
    content_1_M: "选择本项目的性能评估目标，明确评估范围是单台冷水机组、冷水机房系统还是供热系统。热泵改造以及冷热联供系统选项即将推出。",
    content_2_M: "该选择将引导 iECM Spec Builder 后续工作流程，并确定系统边界、所需用户输入、适用的设备配置，以及用于评估改进机会的性能指标。"
  },
  E20200: {
    topic: "项目概况",
    content_1_M: "输入项目基本信息和设计假设，包括项目目的、地点、气象数据、供热应用、设计工况和系统配置。",
    content_2_M: "这些输入使 iECM Spec Builder 能够根据项目现场、气候、应用类型和现有系统定制供热工作流程及计算。"
  },
  E20300: {
    topic: "现有设备参数",
    content_1_M: "添加现有供热设备，并输入每台设备的关键参数，包括设备类型、容量、数量、燃料或能源类型以及效率数据。",
    content_2_M: "这些信息用于定义当前供热系统，并提供建立基线和评估设备替换方案所需的设备数据。"
  },
  E20400: {
    topic: "现场观察",
    content_1_M: "记录客户现场调研中发现的情况、问题、建议、预期收益及相关照片。",
    content_2_M: "现场观察说明实施改造的实际原因，并为能源审计和客户方案提供支持依据。"
  },
  E20500: {
    topic: "基线配置",
    content_1_M: "选择可用的基线数据路径：路径 A 使用供热负荷数据，路径 B 使用能源消耗数据。随后定义运行月份以及适用的能源价格或费率。",
    content_2_M: "所选路径决定月度供热基线的建立方式，以及年度能源成本和节省量的评估方法。"
  },
  E20610: {
    topic: "月度基线",
    content_1_M: "添加或编辑具有代表性的月度运行特征，用于建立供热基线，并估算全年其余月份的运行工况。",
    content_2_M: "代表性运行特征为估算年度供热需求、能源消耗和改造节省量提供一致的基础。"
  },
  E20611: {
    topic: "运行日历",
    content_1_M: "定义系统运行日，例如工作日、周末或全周运行。iECM Spec Builder 随后计算每月相应的运行天数。",
    content_2_M: "运行天数决定供热系统的运行频率，是月度和年度负荷、能源消耗及节省量计算的关键输入。"
  },
  E20612: {
    topic: "运行小时数",
    content_1_M: "根据客户的实际运行时程，输入每月峰时段和非峰时段的每日运行小时数。",
    content_2_M: "这将供热运行分配到正确的时段和气象条件，从而提高供热负荷、能源消耗和成本计算的准确性。"
  },
  E20613: {
    topic: "锅炉运行",
    content_1_M: "选择在峰时段和非峰时段运行的现有锅炉或其他供热设备，然后确认适用的运行参数和性能输入。",
    content_2_M: "这会将现有设备与月度供热需求关联，使 iECM Spec Builder 能够估算基线设备运行和能源消耗。"
  },
  E20615: {
    topic: "月度供热负荷",
    content_1_M: "查看每月峰时段和非峰时段的平均供热负荷。代表月基于输入的负荷特征，其他月份由 iECM Spec Builder 估算。",
    content_2_M: "月度负荷特征定义供热需求基线，用于确定设备运行、计算能源使用并比较改造方案。"
  },
  E20616: {
    topic: "月度锅炉台数",
    content_1_M: "根据供热负荷和可用设备容量，查看每月峰时段和非峰时段所需的现有锅炉或供热设备的最少台数。",
    content_2_M: "设备台数反映现有系统如何满足月度需求，并支持基线能源计算。"
  },
  E20617: {
    topic: "月度能源消耗",
    content_1_M: "查看峰时段和非峰时段的预计月度能源消耗。该估算基于供热负荷、设备运行情况以及现有设备性能。",
    content_2_M: "这将建立改造前能源基线，用于计算年度能源成本，并比较拟议方案可实现的节省量。"
  },
  E20623: {
    topic: "锅炉运行",
    content_1_M: "选择与所报告能源消耗相关的现有锅炉或其他供热设备，然后确认适用的运行参数和性能输入。",
    content_2_M: "这会将能源消耗基线与实际供热设备关联，并支持将能源使用量转换为供热需求和运行要求。"
  },
  E20627: {
    topic: "月度能源消耗",
    content_1_M: "输入或查看客户的月度供热能源消耗，并在适用时将其分配至峰时段和非峰时段。",
    content_2_M: "能源消耗数据是估算月度供热需求、当前能源成本和改造节省量的主要基线输入。"
  },
  E20626: {
    topic: "月度锅炉台数",
    content_1_M: "查看每月峰时段和非峰时段预计所需的现有锅炉或供热设备台数。",
    content_2_M: "这反映现有设备预计如何运行，以满足由能源消耗基线推导出的需求。"
  },
  E20625: {
    topic: "月度供热负荷",
    content_1_M: "查看根据能源消耗数据、运行特征和现有设备性能估算的月度供热负荷。",
    content_2_M: "推导得到的负荷特征为供热需求提供统一基础，使拟议改造方案能够进行选型和比较。"
  },
  E20700: {
    topic: "基线预览",
    content_1_M: "查看基线结果，包括月度供热需求、能源消耗和能源成本，然后下载基线能源审计报告。",
    content_2_M: "这使您能够在进入拟议设备及改造方案分析之前，核实改造前的参考工况。"
  },
  E20800: {
    topic: "设置运行工况",
    content_1_M: "选择拟议热泵类型，并定义改造后的运行工况，包括适用时的负荷侧和热源侧温度。",
    content_2_M: "运行工况决定热泵的制热能力和效率，是准确计算拟议系统性能的关键输入。"
  },
  E20900: {
    topic: "定义新设备",
    content_1_M: "添加拟议热泵选项，并定义每台设备的关键参数。",
    content_2_M: "每个设备选项只需定义一次，iECM Spec Builder 即可确定所需台数，并评估性能、节省量、投资和财务回报。"
  },
  E20901: {
    topic: "热泵选型：digital e-CAT",
    content_1_M: "从 digital e-CAT 中选择热泵，定义设计工况和设备销售价格，并查看可用的性能数据。",
    content_2_M: "digital e-CAT 为改造分析提供一致的设备选型和性能数据，销售价格则用于估算项目资本性支出（CAPEX）。"
  },
  E20902: {
    topic: "热泵选型：月份聚类",
    content_1_M: "当所需热泵在 digital e-CAT 中不可用时，使用“手动设计”。将运行工况相近的月份分组，然后为每组输入设备和性能数据。",
    content_2_M: "月份分组可减少重复数据输入，同时允许在全年具有代表性的运行工况下评估自定义设备。销售价格用于估算资本性支出（CAPEX）。"
  },
  E21000: {
    topic: "改造方案",
    content_1_M: "查看 iECM Spec Builder 生成的方案，并按效率、财务回报或投资进行比较或排序。完成所需配置后生成 ECM 报告。您也可以手动重新配置方案。",
    content_2_M: "这有助于确定合适的客户方案，完善设备配置和财务假设，并生成最终改造报告。"
  },
  E22000: {
    topic: "重新配置的方案",
    content_1_M: "通过选择拟议设备，并设置每个基线月份和运行时段内可运行的最大设备台数，手动配置改造方案。",
    content_2_M: "当自动生成的方案无法完全满足项目需求时，该功能可灵活创建客户定制配置。"
  },
  E21001: {
    topic: "改造配置",
    content_1_M: "查看详细的方案配置，包括最大供热负荷、拟议热泵容量和月度设备运行台数。",
    content_2_M: "这可在完成财务评估和最终报告之前，确认拟议系统的容量选择与配置是否适当。"
  },
  E21002: {
    topic: "ROI 与 NPV",
    content_1_M: "查看并更新全生命周期财务结果，包括能源和成本节省、投资成本、投资回报率（ROI）、投资回收期和净现值（NPV）。",
    content_2_M: "这展示了方案降低运行成本并创造长期财务价值的潜力，帮助客户做出有依据的投资决策。"
  },
  E21004: {
    topic: "拟议设备详情",
    content_1_M: "通过明确哪些现有设备将保留，以及哪些拟议设备将新增或用于替换，定义详细的改造范围。",
    content_2_M: "这可清晰记录设备变更，并支持编制完整、可直接面向客户的改造计划和 ECM 报告。"
  },
  // wizard mode related
  E13000: {
    topic: "快速设置",
    content_1_M: "快速设置收集创建初始基线和改造模型所需的关键信息，包括项目信息、现有设备和拟议设备信息。",
    content_2_M: "即使现场数据有限，iECM 也可以据此进行初步评估。iECM 会利用已提供的输入和参考模型生成初始假设，用户可在计算前查看并调整这些假设。"
  },
  E13001: {
    topic: "检查假设",
    content_1_M: "请输入最低限度的必需数据，包括建筑垂直行业、估算路径、现场冷水机组、参考冷水机组、拟议冷水机组和月度电价。",
    content_2_M: "结合自动生成的假设和默认值，这些数据可支持快速计算和报告生成。"
  },
  E13002: {
    topic: "评估结果",
    content_1_M: "请输入最低限度的必需数据，包括建筑垂直行业、估算路径、现场冷水机组、参考冷水机组、拟议冷水机组和月度电价。",
    content_2_M: "结合自动生成的假设和默认值，这些数据可支持快速计算和报告生成。"
  }
}



// WEBPACK FOOTER //
// ./src/locale/explan/zh.js